import React from "react";
import { MdOutlineSendToMobile } from "react-icons/md";
import { IoDocumentTextOutline, IoDocumentAttachOutline } from "react-icons/io5"
import { BsShieldCheck, BsCashStack } from "react-icons/bs";
import _renderAddress from "./componets/_renderAddress";
import _renderVendor from "./componets/_renderVendor";
import _renderDevice from "./componets/_renderDevice";
import _renderDeviceInfo from "./componets/_renderDeviceInfo";
import _renderRepairType from "./componets/_renderRepairType";
import _selectAddress from "./componets/_selectAddress";
import _selectVendor from "./componets/_selectVendor";
import _selectDevice from "./componets/_selectDevice";
import { Row, Col, Button, Form, Card, Alert } from "react-bootstrap";
import _dropzone from "../../componets/_dropzone";
import apiEndPoints from "../../componets/json/apiEndPoints.json";


class userCreateRequest extends React.Component {

    state = {
        email: this.props.user.userName,
        caseNo: -1,
        shipNo: -1,
        invaddress: null,
        deliveryaddress: null,
        vendor: {
            set: false
        },
        device: {
            set: false
        },
        deviceInfo: {
            alert: {
                variant: "",
                text: "",
                show: false
            },
            imei: "",
            sn: "",
            set: false
        },
        repair: {
            defect1: "",
            defect2: "",
            defect3: "",
            defectdesc: "",
            request: null,
            set: false
        },
        warranty: {
            alert: {
                variant: "",
                text: "",
                show: false
            },
            type: -1,
            proof: null,
            priceAccept: 0,
            datePurch: null,
            files: [],
            set: false
        },
        add: {
            open: false,
            addresstype: "",
        },
        addvendor: {
            open: false,
        },
        adddevice: {
            open: false,
        },
        calendar: [],
        faultCodes: [],
        requestId: ""
    }

    createRequest = async () => {
        const _res = await this.props._api({
            ...this.props,
            method: apiEndPoints.britex.service.ServiceRequest.method,
            endpoint: apiEndPoints.britex.service.ServiceRequest.endPoint,
            data: this.props._encrypt(JSON.stringify(this.state)),
            param: "",
        });
        if (_res.status == 200) {
            this.setState({ requestId: _res.data.requestId });
        }
    }

    confirmRepair = () => {
        this.setState({ repair: { ...this.state.repair, set: true } });
    }

    getFaultCodes = async () => {
        this.setState({ loading: { ...this.state.loading, status: true } });
        const _res = await this.props._api({
            ...this.props,
            method: "get",
            endpoint: apiEndPoints.britex.LookUpValue.faultcodes_v2.replace("{vendor}", this.state.vendor?.FirmCode),
            param: "",
        });
        this.setState({ loading: { ...this.state.loading, status: false } });
        if (_res.status == 200) {
            this.setState({ faultCodes: JSON.parse(this.props._decrypt(_res.data)) });
        }
    }

    setFile = (f) => {
        this.setState({ warranty: { ...this.state.warranty, files: f } })
    }

    confirmDeviceInfo = () => {
        this.setState({ deviceInfo: { ...this.state.deviceInfo, alert: { variant: "", show: false, text: "" } } });
        if (this.state.deviceInfo.imei.length < 6 && this.state.deviceInfo.sn.length < 4) {
            this.setState({ deviceInfo: { ...this.state.deviceInfo, alert: { variant: "danger", show: true, text: "IMEI nebo S/N musí být vyplněno" } } });
            return;
        }
        this.setState({ deviceInfo: { ...this.state.deviceInfo, set: true } });
    }

    confirmWarranty = () => {
        this.setState({ warranty: { ...this.state.warranty, alert: { variant: "", show: false, text: "" } } });

        if (this.state.warranty.type == 2) {

        } else {
            //kontrolovat datu zda není více jak 810 dní od teď
            var purchDate = new Date(this.state.warranty.datePurch.year, this.state.warranty.datePurch.month, this.state.warranty.datePurch.day)
        }
        this.setState({ warranty: { ...this.state.warranty, set: true } });
    }

    componentDidMount() {
        this.props.setHeaderPage({
            Icon: <MdOutlineSendToMobile className="c-placeholder c-green" />,
            Title: "Vytvořit požadavek na opravu",
            SubTitle: "",
        });
    }

    setVendor = (e) => {
        this.setState({ vendor: { ...e, set: true } });
    }

    setDevice = (e) => {
        this.setState({ device: { ...e, set: true } });
    }

    selectInvAddr = (e, idx) => {
        this.setState({ invaddress: e, add: { ...this.state.add, open: false } })
    }

    selectDelivAddr = (e) => {
        this.setState({ deliveryaddress: e, add: { ...this.state.add, open: false } })
    }

    

    render() {
        var purchDate = new Date(2019, 1, 1)
        return (<>
            {this.state.requestId != "" && (
                <>
                
                </>
            )}
            {this.state.requestId == "" && (
                <>
                    <Row className="mb-2">
                        <Col>
                            <h6><strong>Fakturační adresa</strong></h6>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col>
                            {!this.state.invaddress ?

                                <>
                                    <Button variant="success" size="sm" onClick={() => this.setState({ add: { ...this.state.add, open: true, addresstype: "F" } })}>Vybrat fakturační adresu</Button>
                                    <_selectAddress select={this.selectInvAddr} {...this.state.add} {...this.props} onHide={() => this.setState({ add: { ...this.state.add, open: false } })} />
                                </>
                                :
                                <_renderAddress e={this.state.invaddress} idx={0} />
                            }
                        </Col>
                    </Row>

                    {this.state.invaddress && (
                        <>
                            <Row className="mb-2">
                                <Col>
                                    <h6><strong>Dodací adresa</strong></h6>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col>
                                    {!this.state.deliveryaddress ?

                                        <>
                                            <Button variant="warning" className="me-4" size="sm" onClick={() => this.selectDelivAddr(this.state.invaddress, 0)}>Stejná jako fakturační</Button>
                                            <Button variant="success" size="sm" onClick={() => this.setState({ add: { ...this.state.add, open: true, addresstype: "D" } })}>Vybrat dodací adresu</Button>
                                            <_selectAddress select={this.selectDelivAddr} {...this.state.add} {...this.props} onHide={() => this.setState({ add: { ...this.state.add, open: false } })} />
                                        </>
                                        :
                                        <_renderAddress e={this.state.deliveryaddress} idx={0} />
                                    }
                                </Col>
                            </Row>
                        </>
                    )}

                    <Row className="mb-2">
                        <Col xs={6}>
                            {this.state.deliveryaddress && (
                                <>
                                    <Row className="mb-2">
                                        <Col>
                                            <h6><strong>Výrobce</strong></h6>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {!this.state.vendor.set && (
                                                <>
                                                    <Button variant="success" size="sm" onClick={() => this.setState({ addvendor: { ...this.state.addvendor, open: true } })}>Vybrat výrobce</Button>
                                                    {this.state.addvendor.open && (
                                                        <_selectVendor select={this.setVendor} {...this.state.addvendor} {...this.props} onHide={() => this.setState({ addvendor: { ...this.state.addvendor, open: false } })} />
                                                    )}
                                                </>
                                            )}
                                            {this.state.vendor.set && (
                                                <>
                                                    {this.state.addvendor.open && (
                                                        <_renderVendor e={this.state.vendor} />
                                                    )}
                                                </>
                                            )}

                                        </Col>
                                    </Row>
                                </>
                            )}
                        </Col>
                        <Col xs={6}>
                            {this.state.vendor.set && (
                                <>
                                    <Row className="mb-2">
                                        <Col>
                                            <h6><strong>Typ přístroje</strong></h6>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {!this.state.device.set && (
                                                <>
                                                    <Button variant="success" size="sm" onClick={() => this.setState({ adddevice: { ...this.state.adddevice, open: true } })}>Vybrat typ</Button>
                                                    {this.state.adddevice.open && (
                                                        <_selectDevice select={this.setDevice} {...this.state.adddevice} {...this.state} {...this.props} onHide={() => this.setState({ adddevice: { ...this.state.adddevice, open: false } })} />
                                                    )}
                                                </>
                                            )}
                                            {this.state.device.set && (
                                                <>
                                                    {this.state.adddevice.open && (
                                                        <_renderDevice e={this.state.device} />
                                                    )}
                                                </>
                                            )}

                                        </Col>
                                    </Row>
                                </>
                            )}
                        </Col>
                    </Row>
                    {this.state.device.set && (
                        <>
                            <_renderDeviceInfo setState={(e) => {
                                this.setState(e)
                            }} {...this.state} confirmDeviceInfo={this.confirmDeviceInfo} />

                            {this.state.deviceInfo.set && (
                                <>
                                    <_renderRepairType setState={(e) => {this.setState(e)}} {...this.state} {...this.props} confirmWarranty={this.confirmWarranty} setFile={this.setFile} />
                                    {this.state.warranty.set && (
                                        <>
                                            {!this.state.repair.set && (
                                                <>
                                                    <Row className="mb-2">
                                                        <Col>
                                                            <h6><strong>Závada</strong></h6>
                                                            <Row className="mt-4">
                                                                <Form.Control onChange={(e) => this.setState({ repair: { ...this.state.repair, defectdesc: e.target.value } })} type="textarea" rows="4" />
                                                                <Form.Text>Popis závady</Form.Text>
                                                            </Row>
                                                        </Col>

                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Col xs={12} className="d-flex justify-content-end">
                                                            <Button variant="success" size="sm" onClick={this.confirmRepair}>Potvrdit</Button>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                            {this.state.repair.set && (
                                                <>
                                                    <Row className="mb-2">
                                                        <Col>
                                                            <h6><strong>Závada</strong></h6>
                                                            <Row className="mt-4">
                                                                <Card bg="uni">
                                                                    <Card.Body>
                                                                        {this.state.repair.defectdesc}
                                                                    </Card.Body>
                                                                </Card>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Col xs={12} className="d-flex justify-content-end">
                                                            <Button variant="success" size="sm" onClick={this.createRequest}>Vytvořit požadavek</Button>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </>
                                    )}
                                </>

                            )}
                        </>
                    )}
                </>
            )}

        </>)
    }
}
export default userCreateRequest;